module.exports = __webpack_public_path__ + "static/media/valk-cadeaucard-pin.8c532002.png";